<template>
  <div class="content">
    <p 
      :class="isHideFlag ? `line-5`: ''" 
      ref="con"
      v-if="content"
      style="-webkit-box-orient: vertical;"
      v-html="content.replace(/(\r\n|\n|\r)/gm, '<br />')"></p>
    <div :class="isHideFlag?'unfold':'fold'" v-if="isHideFlag" @click.stop="unfold">{{unfoldText}} <span class="arrow-down"></span></div> 

    <!--  img -->
    <div class="image" v-if="!!image">
        <img :src="image" alt="" >
    </div>
  </div>
</template>

<script>
import api from 'src/constants/appapi'
export default {
  props: {
    content: {
      type: String,
    },
    image: {
      type: String,
    }
  },
  data() {
    return {
      terminalFlag:'',
      isHideFlag: false,
      isNeedUnfold: false,
      unfoldText: "展开",
      lineNum: 5,
      // con: '',
    }
  },
  computed: {
    contentFormat(){
      const str1 = this.content.replace(/ /g, "");
      const str2 = str1.replace(/(\\r\\n|\\n|\\r)/gm, '<br />');
      // console.log('str2',str2,'str1',str1)
      return str2;
    }
  },
  watch:{
    'content'(newVal, oldVal) {
      if(newVal && newVal !== oldVal) {
          this.formatDesc(this.lineNum)
      }
    },
  },
  mounted(){
    window.appapi = api
    this.terminalFlag = api.checkTerminal()
    this.$nextTick(()=>{
      this.formatDesc(this.lineNum)
    })
  },
  methods:{
    formatDesc(lineNum) {
      this.$nextTick(function() {
          console.log("计算高度")
          const n = lineNum
          const conEl = this.$refs.con
          if(!conEl) return;
          const finalStyle = conEl.currentStyle ? conEl.currentStyle : window.getComputedStyle(conEl, null)
          // console.log(n, parseInt(finalStyle.height),parseInt(finalStyle.lineHeight) ,parseInt(finalStyle.lineHeight)* n)
          if(parseInt(finalStyle.height) > parseInt(finalStyle.lineHeight)* n){
            this.isNeedUnfold = true
            //this.isHideFlag = true
          }
      });
    },
    unfold() {
      this.isHideFlag = !this.isHideFlag;
      this.unfoldText = this.unfoldText === '展开' ? '收起' : '展开';
    },
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.content {
    position: relative;
    margin-top: 10px;
    line-height: 56px;
    font-size: 32px;
    text-align: justify;
    color: #000;
    word-wrap:break-word;
    p{
      word-break: break-word;
    }
    .line-5{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden;
      text-align: justify;
    }
    .image{
      margin-top: 10px;
      img{
        width: 160px;
        height:173px
      }
    }
  }
  .unfold,.fold{
    display: flex;
    align-items: center;
    font-size: 24px;
    line-height: 52px;
    padding-top: 10px;
    padding-left: 20px;
    margin-left: -20px;
    vertical-align: middle;
    color: #333641;
    letter-spacing: 0;
    span.arrow-down {
      width: 0;
      height: 0;
      margin-left: 8px;
      display: inline-block;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-top: 20px solid #5D6266;
      // transform: rotate(-180deg);
    }
  }
  .fold{
    // display: block;
    // text-align: right;
    // float: none;
    span.arrow-down{
      background: url("~images/icon_msg_up.png") center/26px 24px no-repeat;
    }
  }
</style>


// WEBPACK FOOTER //
// theme-remark.vue?10dd4016